<p-breadcrumb
  [model]="[{ label: 'Gerir Contratos', routerLink: ['/contract-templates'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Gerir Contratos</h5>
      <p>Cadastre e mantenha os contratos por estado</p>
    </div>
    <p-button label="Novo Contrato" routerLink="/contract-templates/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="contractTemplates()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex flex-wrap gap-5 items-center">
      <p>Filtrar por:</p>

      <div class="w-100">
        <p-select
          [options]="countries"
          optionLabel="label"
          optionValue="value"
          [showClear]="true"
          placeholder="País"
          class="w-full"
          [(ngModel)]="countryFilter"
          (ngModelChange)="onFilterChange()"
        />
      </div>

      <div class="w-100">
        <p-select
          [options]="states"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [showClear]="true"
          placeholder="Estado"
          class="w-full"
          [(ngModel)]="stateFilter"
          (ngModelChange)="onFilterChange()"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>País</th>
      <th>Estado</th>
      <th>Arquivo</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.country ? getCountryLabel(item.country) : '-' }}</td>
      <td>{{ getStateLabel(item.state) || '-' }}</td>
      <td>
        @if (item.fileUrl) {
          <a
            [href]="item.fileUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="text-primary hover:underline"
          >
            {{ item.fileName || 'Visualizar arquivo' }}
          </a>
        } @else {
          {{ item.fileName || '-' }}
        }
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/contract-templates/update/' + item.id"
          title="Editar contrato"
        />
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
